let table = $('.add-in-group');
let mass = [];
let popup = $('._add-in-group');

if (table.length) {

    $('.addEmployerGroup').click(function () {
        teste();
    })

}


function teste() {
    let allCheckedChecbox = table.find('input:checked');
    mass = [];

    //console.log(allCheckedChecbox);

    if (allCheckedChecbox.length) {
        allCheckedChecbox.each(function (index, element) {
            let employesNames = $(element).parents('td._align-l').siblings('.td_widt-svg').find('.styled-table__td-name').text();
            mass.push(employesNames);
        })

        let nameInTag = mass.map( name => '<p class="textarea-names__p">' + name + '</p>').join('');
        popup.find('.textarea-names').html(nameInTag);
    };
}